export default __webpack_public_path__ + "static/fj-8bcb42f886dfb05d23281ba398d7cb0f.svg";